module.exports = __webpack_public_path__ + "static/media/figure12.4bd224ba.png";